module.exports = __webpack_public_path__ + "static/media/picto_ordi_formation_continuelle.c25aa365.svg";